import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import ScrollTriggeredCounter from './ScrollTriggeredCounter';
import ImageRevealScroll from './ImageRevealScroll';
import AnimatedGradient from './AnimatedGradient';
import SplitScreenReveal from './SplitScreenReveal';
import RotatingHeroText from './RotatingHeroText';
import InfiniteLogoCrawler from './InfiniteLogoCrawler';

const FEATURE_COMPONENT_MAP = {
  'Scroll-Triggered Number Counters': ScrollTriggeredCounter,
  'Image Reveal on Scroll (Curtain Effect': ImageRevealScroll,
  'Animated Gradient Background': AnimatedGradient,
  'Split-Screen Reveal': SplitScreenReveal,
  'Rotating Hero Text with Fixed Prefix': RotatingHeroText,
  'Infinite Logo Crawler': InfiniteLogoCrawler,
};

const FeaturePreviewWrapper = ({ 
  featureTitle, 
  data = {}, 
  isVisible = false,
  position = { x: 0, y: 0 },
  className = ''
}) => {
  const PreviewComponent = FEATURE_COMPONENT_MAP[featureTitle];

  if (!PreviewComponent || !isVisible) {
    return null;
  }

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.9 }}
        transition={{ duration: 0.2 }}
        className={`fixed z-50 bg-white rounded-xl shadow-2xl overflow-hidden ${className}`}
        style={{
          width: '500px',
          height: '350px',
          left: `${position.x}px`,
          top: `${position.y}px`,
          pointerEvents: 'none',
        }}
      >
        {/* Preview Container */}
        <div className="relative h-full w-full">
          <PreviewComponent data={data} />
          
          {/* Feature Label */}
          <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-4">
            <h4 className="text-white font-semibold text-sm">
              {featureTitle}
            </h4>
          </div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
};

export default FeaturePreviewWrapper;

